import { IComboSelectBehavior } from "./IComboSelectBehavior";

export interface IComboSelectBehaviorSpecifiable {
  comboSelectBehavior: IComboSelectBehavior;
}

export function instanceOfIComboSelectBehaviorSpecifiable(instance: any): instance is IComboSelectBehaviorSpecifiable {
  return instance
    && (instance.comboSelectBehavior !== undefined);
}
